export default "__VITE_PUBLIC_ASSET__ea1530a0__"